import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long fetched data is considered fresh
      staleTime: 1000 * 60 * 15, // 15 minutes
      throwOnError: true,
      retry: 1,
    },
    mutations: {
      // This is essenteial for impersonated user write-only mode error
      throwOnError: true,
      retry: 1,
    },
  },
})
